import React from "react";
import { Collapse } from "antd";
import { FormatDateTime } from "../../../utility/format";

const { Panel } = Collapse;

export default function Rejectjobdetail({ jobData }) {
  const { result_reject } = jobData ?? null;
  return (
    <>
      {result_reject &&
      result_reject !== undefined &&
      result_reject.length > 0 ? (
        <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
          <Panel header={<h4>Reject Job History</h4>} key="1">
            <div className="d-flex align-content-md-start flex-wrap w-100">
              {result_reject.map((data, index) => (
                <div
                  className="col col-12"
                  key={`reject_job_detail_index_${index}`}
                >
                  <div className="card-header c-blue px-2 py-1">
                    <span>Sub Reject Job</span>
                  </div>
                  <div className="card-body py-2">
                    <div className="col-7">
                      <p className="card-text">
                        Reson : {data.reject_service_ma_remark}
                      </p>
                      <p className="card-text">
                        Time :
                        <FormatDateTime
                          text={data.request_reject_date}
                        ></FormatDateTime>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Panel>
        </Collapse>
      ) : null}
    </>
  );
}
